import type { Options } from '@contentful/rich-text-react-renderer'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import type { Document } from '@contentful/rich-text-types'
import { memo } from 'react'

import Icon from '../Icon/Icon'
import { generateIdentifier } from '@susu/headless-commerce/utils/identifier'
import styles from './ButtonWithIcon.module.scss'

export type ContentProps = {
  hasText: boolean
  iconName: string
  json: Document
  options: Options
}

export const Content = memo(function Content({
  hasText,
  iconName,
  json,
  options,
}: ContentProps) {
  // Create custom renderer that splits text on newlines and wraps each line in a span
  const customOptions: Options = {
    ...options,
    renderText: (text: string) => {
      // Split text on newlines (both \n and \r\n)
      const lines = text.split(/\r?\n/)

      return (
        <>
          {lines.map((line) => (
            <span key={generateIdentifier()} className={styles.textLine}>
              {line}
            </span>
          ))}
        </>
      )
    },
  }

  return (
    <>
      <span className={styles.icon}>
        <Icon icon={iconName} />
      </span>
      {hasText && <div>{documentToReactComponents(json, customOptions)}</div>}
    </>
  )
})
